import { Box, Typography } from "@mui/material";
import React from "react";
import moment from "jalali-moment";

const MessageCard = (props) => {
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      alignItems="end"
      width={{ xs: "65%", sm: "60%", md: "40%" }}
      bgcolor="#FAFAFA"
      borderRadius={4}
      px={6}
      py={3}
      my={1}
      key={props.id}
    >
      <Typography variant="h2" color="#747474" my={1}>
        {props.senderFullName && "فرستنده: "}
        {` ${props.senderFullName}`}
        {props.senderFullName && " -"}{" "}
        {moment(props.createdTime.split("T")[0]).format("jYYYY/jMM/jDD")}
      </Typography>
      <Typography variant="h2" color="#747474" my={1} textAlign="right">
        {props.title}
      </Typography>
      <Typography variant="h2" my={1} textAlign="right">
        {props.body}
      </Typography>
      {/* <Typography variant="h2" textAlign="right" >
        ...ما اینجاییم که کمکت کنیم... بیا شروع کنیم
      </Typography> */}
    </Box>
  );
};

export default MessageCard;
